// Offline fallback for the tour catalogue.
//
// The live catalogue — tours, line-ups, and the city schedule with its ticket
// links — lives in the `tours` / `tour_stops` / `tour_artists` /
// `tour_artist_options` tables and is edited in admin/tours.php. Components
// read it through useTours(), which serves this list only when the API is
// unreachable or the tours migration has not been run yet.
//
// `id` is what the API stores in tour_booking_requests.tour, `slug` is the route.

export const TOURS = [
  {
    id: "dashain-tihar-dhamaka",
    slug: "dashain-tihar-dhamaka",
    theme: "dhamaka",
    presenter: "3E Entertainment presents",
    name: "Dashain Tihar Dhamaka",
    edition: "USA Tour 2026",
    tagline: "The biggest festival. The biggest celebration. The biggest musical tour of the year.",
    lineup: "Samikshya Adhikari & Shiva Pariyar",
    windowLabel: "September–November 2026",
    windowShort: "Sep–Nov 2026",
    regionLabel: "Cities across the USA",
    poster: "/images/dashain-tihar-dhamaka-usa-tour.jpg",
    posterAlt: "Dashain Tihar Dhamaka USA Tour 2026 poster featuring Samikshya Adhikari and Shiva Pariyar",
    cardBlurb: "A festival-season celebration built for community halls, cultural festivals, and full-scale concerts.",
    heroHeadline: ["Bring the celebration", "to your city."],
    heroBlurb:
      "Book Samikshya Adhikari and Shiva Pariyar for a concert, festival, or community event during the Dashain–Tihar season.",
    stamp: { top: "SEP", bottom: "NOV", year: "2026" },
    artists: [
      { name: "Samikshya Adhikari", role: "Singer · Live performer", image: "/images/samikshya-adhikari-tour.jpeg" },
      { name: "Shiva Pariyar", role: "Singer · Live performer", image: "/images/shiva-pariyar-tour.jpeg" },
    ],
    artistOptions: [
      { value: "both", label: "Both artists" },
      { value: "samikshya", label: "Samikshya Adhikari" },
      { value: "shiva", label: "Shiva Pariyar" },
    ],
    defaultArtist: "both",
    dateRange: { min: "2026-09-26", max: "2026-11-14" },
    dateHint: "Dates must fall between September 26 and November 14, 2026.",
    tourSchedule: [
      { date: "2026-09-26", location: "Dallas, TX", status: "confirmed" },
      { date: "2026-09-27", location: "Austin, TX", status: "confirmed" },
      { date: "2026-10-02", location: "Columbus", status: "confirmed" },
      { date: "2026-10-03", location: "Akron", status: "confirmed" },
      { date: "2026-10-04", location: "Harrisburg", status: "confirmed" },
      { date: "2026-10-09", location: "Open", status: "open" },
      { date: "2026-10-10", location: "Lancaster, PA", status: "confirmed" },
      { date: "2026-10-11", location: "Ashburn, VA", status: "confirmed" },
      { date: "2026-10-17", location: "Grand Rapids", status: "confirmed" },
      { date: "2026-10-18", location: "Chicago", status: "confirmed" },
      { date: "2026-10-24", location: "Open", status: "open" },
      { date: "2026-10-25", location: "Raleigh", status: "confirmed" },
      { date: "2026-10-30", location: "Nebraska", status: "confirmed" },
      { date: "2026-10-31", location: "Open", status: "open" },
      { date: "2026-11-01", location: "Manchester", status: "confirmed" },
      { date: "2026-11-06", location: "Open", status: "open" },
      { date: "2026-11-07", location: "Florida", status: "confirmed" },
      { date: "2026-11-13", location: "Open", status: "open" },
      { date: "2026-11-14", location: "Open", status: "open" },
    ],
    phones: ["+1 (571) 355-5165", "+1 (703) 509-1127"],
    metaTitle: "Book the Dashain Tihar Dhamaka USA Tour 2026 | 3E Entertainment",
    metaDescription:
      "Request Samikshya Adhikari and Shiva Pariyar for your city or event during the September–November 2026 USA Tour.",
  },
  {
    id: "mukti-revival",
    slug: "mukti-revival",
    theme: "revival",
    presenter: "3E Entertainment presents",
    name: "Mukti & Revival",
    edition: "USA Tour 2026",
    tagline: "The legacy. The blues. The revival.",
    lineup: "Mukti Shakya & Revival — live full band",
    windowLabel: "September–October 2026",
    windowShort: "Sep–Oct 2026",
    regionLabel: "Cities across the USA",
    poster: "/images/mukti-revival-usa-tour.jpg",
    posterAlt: "Mukti & Revival USA Tour poster featuring the full band in front of an American flag",
    cardBlurb: "Nepal's blues-rock legends on the road — a full-band live show for theaters, clubs, and festival stages.",
    heroHeadline: ["The legacy on stage,", "in your city."],
    heroBlurb:
      "Book Mukti Shakya and Revival for a full-band blues-rock night — theater, club, festival, or private stage anywhere in the USA.",
    stamp: { top: "SEP", bottom: "OCT", year: "2026" },
    artists: [{ name: "Mukti & Revival", role: "Blues rock · Full band", image: "/images/mukti-revival-usa-tour.jpg" }],
    artistOptions: [
      { value: "mukti_revival", label: "Mukti Shakya & Revival — full band" },
      { value: "mukti_solo", label: "Mukti Shakya — acoustic set" },
    ],
    defaultArtist: "mukti_revival",
    dateRange: { min: "2026-09-11", max: "2026-10-18" },
    dateHint: "Dates must fall between September 11 and October 18, 2026.",
    tourSchedule: [
      { date: "2026-09-11", location: "Houston", status: "confirmed" },
      { date: "2026-09-12", location: "Dallas", status: "confirmed" },
      { date: "2026-09-18", location: "Open", status: "open" },
      { date: "2026-09-19", location: "St. Louis", status: "confirmed" },
      { date: "2026-09-25", location: "Open", status: "open" },
      { date: "2026-09-26", location: "Hollins, NH", status: "confirmed" },
      { date: "2026-10-02", location: "Charlotte, NC", status: "confirmed" },
      { date: "2026-10-03", location: "Open", status: "open" },
      { date: "2026-10-09", location: "Open", status: "open" },
      { date: "2026-10-11", location: "DTFest", status: "confirmed" },
      { date: "2026-10-17", location: "Open", status: "open" },
      { date: "2026-10-18", location: "Open", status: "open" },
    ],
    phones: ["+1 (703) 509-1127"],
    metaTitle: "Book the Mukti & Revival USA Tour 2026 | 3E Entertainment",
    metaDescription:
      "Bring Mukti Shakya and Revival to your city — request a date for the 2026 Mukti & Revival USA Tour from 3E Entertainment.",
  },
];

export const getTour = (slug) => TOURS.find((tour) => tour.slug === slug);
